module.exports = __webpack_public_path__ + "img/spin4.5dd51caa.png";